import * as React from 'react';
import {FaCheck} from "react-icons/fa";

const CusFaCb = (props) => {

    return(
        <div className="fbaPSize">        
    
            <div style={{float:'left',width:'5%',paddingTop:'3%'}}>
                    <FaCheck className="fbaCheck" />
            </div>
               
            <div style={{float:'left',width:'95%',paddingTop:'3%',paddingRight:'3%'}}>{props.lblname}</div>   
        
            {/* <div style={{float:'left',width:'5%',paddingTop:'3%'}}>
                <FaCheck className="fbaCheck" />
            </div>
            <div style={{float:'right',width:'95%',paddingTop:'3%'}}>{props.lblname}</div>          */}
        </div>
    )
}

export default CusFaCb;